import { useEffect, useState } from "react";
import { isSignedIn, subscribeAuthChange } from "../utils/authStorage";

/**
 * Sign-in state as something React actually re-renders on.
 *
 * Components used to read localStorage directly during render, which meant the
 * value was captured once and never changed again. When a request came back
 * 401 and the session was cleared, an already-mounted header went on showing
 * the signed-in menu and the user's avatar until a full navigation — the
 * reported symptom of arriving from the marketing site with an expired session
 * and being shown a signed-in page that could not do anything.
 *
 * This subscribes, so clearing the session updates the UI immediately, in this
 * tab and in any other tab that has the app open.
 *
 * It is still only a hint about what to OFFER. Every protected request is
 * authorised by the server from an HttpOnly cookie this code cannot see.
 */
export default function useSignedIn() {
  const [signedIn, setSignedIn] = useState(() => isSignedIn());

  useEffect(() => {
    // Re-read on mount as well: the value may have changed between the
    // initial state being computed and the effect running.
    setSignedIn(isSignedIn());
    return subscribeAuthChange(() => setSignedIn(isSignedIn()));
  }, []);

  return signedIn;
}
